import withAuthorization from './withAuthorization';

export default withAuthorization;
